import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";

export const getExtraBooks = (state: ReducerFromState<ExtraReducer>): number[] => state.extra.books;